import { useState } from 'react';
import './section-cta.css';
import { connectStorageEmulator } from 'firebase/storage';

const CtaSection = () => {
  const [showProgress, setShowProgress] = useState(true);

  const [showAlert, setShowAlert] = useState(false);

  const defaultFields = {
    firstname: '',
    email: '',
    mobile: '',
    message: '',
  };

  const [formFields, setFormFields] = useState(defaultFields);

  const { firstname, email, mobile, message } = formFields;

  const formFieldsHandler = (e) => {
    const { name, value } = e.target;
    setFormFields({ ...formFields, [name]: value });
  };
  const contactFormHandler = async (e) => {
    e.preventDefault();
    // setShowProgress(false);
    const submitBtn = document.querySelector('.cta-btn-submit');
    submitBtn.textContent = 'Sending...';

    const result = await fetch('/.netlify/functions/nodemailer-send-msg', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email, name: firstname, message: message }),
    });

    // const response = await result.json();

    if (result.status === 200) {
      console.log('hit');
      const submitBtn = document.querySelector('.cta-btn-submit');
      submitBtn.textContent = 'Send';
      // setShowProgress(true);
      // setShowAlert(true);
      // addContactFormDetails(formFields);
      setFormFields(defaultFields);
    } else {
      alert('error');
    }
  };
  return (
    <div className="section-cta" id="cta-section">
      <div className="container">
        <div className="cta-box">
          <div className="cta-text-box">
            <h3 className="header-cta">Get a Free Counseling Now!</h3>
            <p className="cta-description">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus illo accusantium aliquid culpa sapiente mollitia.
            </p>
            <form className="cta-form" onSubmit={contactFormHandler}>
              <div>
                <label for="name">Full Name</label>
                <br />
                <input
                  type="text"
                  id="name"
                  name="firstname"
                  placeholder="John Doe"
                  required
                />
              </div>
              <div>
                <label for="email">Email</label>
                <br />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="me@example.com"
                  required
                />
              </div>
              <div>
                <label for="message">Message</label>
                <br />
                <input
                  type="text"
                  multiple
                  id="message"
                  name="message"
                  placeholder="Message"
                  required
                />
              </div>
              <div>
                <label for="mobile">Mobile</label>
                <br />
                <input
                  type="tel"
                  id="mobile"
                  placeholder="9999999999"
                  name="mobile"
                />
              </div>
              <input type="submit" className="cta-btn-submit" />
            </form>
          </div>
          <div className="cta-image"></div>
        </div>
      </div>
    </div>
  );
};

export default CtaSection;
